/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'contacts': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.25 26.25',
    data: `<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M2.94 8.75H0V2.94A2.84 2.84 0 0 1 .85.85 2.84 2.84 0 0 1 2.94 0h5.81v2.94H2.94zm0 14.56h5.81v2.94H2.94a2.83 2.83 0 0 1-2.09-.85A2.83 2.83 0 0 1 0 23.31V17.5h2.94zM17.23 9a5.56 5.56 0 0 1 1.64 4.1 5.61 5.61 0 0 1-5.74 5.74 5.61 5.61 0 0 1-5.74-5.74A5.56 5.56 0 0 1 9 9a5.78 5.78 0 0 1 8.2 0zm-2.05 6.15a2.78 2.78 0 0 0 .82-2.02 2.8 2.8 0 0 0-2.87-2.87 2.8 2.8 0 0 0-2.87 2.87 2.78 2.78 0 0 0 .82 2.05 3 3 0 0 0 2.05.89 3 3 0 0 0 2.05-.89zM25.4.85a2.84 2.84 0 0 1 .85 2.08v5.82h-2.94V2.94H17.5V0h5.81a2.84 2.84 0 0 1 2.09.85zM23.31 17.5h2.94v5.81a2.92 2.92 0 0 1-2.94 2.94H17.5v-2.94h5.81z" id="Ebene_1" data-name="Ebene 1"/></g>`
  }
})



// WEBPACK FOOTER //
// ./src/icons/contacts.js